import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Link from './Link';

type Props = {}

const SimpleFooter: React.FC<Props> = () => {
  const d = new Date();
  let year = d.getFullYear();
  const { isAuthenticated } = useAuth();
  const customerServiceLink = isAuthenticated ? "/kontakt" : "https://qstar.se/kontakt";


  return (
    <footer>
      <div className="footer-inner Row">
        <div className="footer-content">
          <nav className="footer-content__nav">
            <a href="https://qstar.se/kundklubbsvillkor" target="_blank" rel="noopener noreferrer">Kundklubbsvillkor</a>
            <a href="https://qstar.se/integritetspolicy" target="_blank" rel="noopener noreferrer">Integritetspolicy</a>
            <Link href={customerServiceLink} openNewTab={!isAuthenticated} ariaLabel="Kontakta kundservice" >Kundservice</Link>
          </nav>
          <p className="no-margin">© {year} Qstar. Alla rättigheter förbehållna.</p>
        </div>
      </div>

    </footer>
  )
}
export default SimpleFooter
